import { Carousel, useIsWindowBiggerThan, useMediaDevice } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'
import { mapProductPage } from '@websrc/DataMappers/mapProductPage'
import { breakpoints, styles } from 'leds'
import React from 'react'

import * as SC from './ProductInfoCarousel.style'

interface ProductInfoCarouselProps {
  assets: ReturnType<typeof mapProductPage>['product_details']['assets']
}

export const ProductInfoCarousel: React.FC<ProductInfoCarouselProps> = ({ assets }) => {
  const device = useMediaDevice()
  const isScreenMedium = useIsWindowBiggerThan(breakpoints.m)

  const galleryPagination =
    assets.length > 1 && isScreenMedium
      ? assets.map(({ thumbnail }, i) => (
          <SC.GalleryPaginationItem key={i}>
            <SC.GalleryPaginationAsset
              as={Asset}
              height={55}
              sizes={'(min-width: 1024px) 85px'}
              srcSetWidths={[85]}
              thumbnail={thumbnail}
              video={undefined}
              width={85}
            />
          </SC.GalleryPaginationItem>
        ))
      : undefined

  const calculateImageSizes = () => {
    switch (device) {
      case 'desktop':
        return { height: 716, width: 1075 }
      case 'tablet':
        return { height: 337, width: 589 }
      default:
        return { height: 124, width: 216 }
    }
  }

  return (
    <Carousel
      className={styles({
        display: 'flex',
        flexDirection: 'column',
      })}
      customActiveClass={styles({
        borderBottomWidth: 2,
        borderBottomStyle: 'solid',
        borderColor: 'blue5',
      })}
      customPagination={galleryPagination}
      hidePaginationDots={true}
      itemsPerPage={1}
    >
      {assets.map(({ thumbnail, video }, i) => (
        <div
          className={styles({ width: 'full', display: 'flex', justifyContent: 'center' })}
          key={i}
        >
          <SC.GalleryItemAsset
            as={Asset}
            height={calculateImageSizes().height}
            lazyLoading={i !== 0}
            sizes={'(min-width: 1024px) 800px, (min-width: 600px) 600px, 200px'}
            srcSetWidths={[200, 600, 800]}
            thumbnail={thumbnail}
            video={video}
            width={calculateImageSizes().width}
          />
        </div>
      ))}
    </Carousel>
  )
}
